import React from 'react';
import { SupportedLanguages } from '../helpers/i18n';
import en1 from '../assets/en-x1.png';
import en2 from '../assets/en-x2.png';
import en3 from '../assets/en-x3.png';
import fr1 from '../assets/fr-x1.png';
import fr2 from '../assets/fr-x2.png';
import fr3 from '../assets/fr-x3.png';
import styles from './LanguagePicker.module.scss';
import { useCallback } from 'react';
import useLocalize from '../hooks/use-localize';
import { useTranslation } from 'react-i18next';

const Flags = Object.freeze({
  en: [en1, en2, en3],
  fr: [fr1, fr2, fr3],
});

const LanguagePicker = () => {
  const { i18n } = useTranslation();
  const { localize } = useLocalize();

  const handleOnChange = useCallback(
    (event) => {
      const {
        target: { value },
      } = event;
      i18n.changeLanguage(value);
    },
    [i18n]
  );

  return (
    <div className={styles.wrapper}>
      {SupportedLanguages.map((lang) => {
        const id = `lang-${lang}`;
        return (
          <React.Fragment key={id}>
            <input className={styles.langSelector} checked={lang === i18n.resolvedLanguage} id={id} name='language' onChange={handleOnChange} type='radio' value={lang} />
            <label htmlFor={id}>
              <img className={styles.flag} src={Flags[lang][0]} srcSet={`${Flags[lang][1]} 2x, ${Flags[lang][2]} 3x`} width='20' height='15' alt={localize(`language.${lang}`)} />
            </label>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default LanguagePicker;
